import {StatusChip} from 'components/DSYS/StatusChip';
import {t} from 'i18next';
import {toCalendarDate, toShortDate} from 'views/workstreams/utils';

/**
 * /workstreams detail: "Archived Oct 15" before the title. Archiving
 * leaves the status and update history as they were, so this is where it shows.
 * Legacy archived workstreams have no archive update, so no date.
 */
export const ArchivedTitleChip = ({archivedAt}: {archivedAt?: string}) => {
  const archived = t('archived').toString();
  const label = archivedAt ? `${archived} ${toShortDate(toCalendarDate(archivedAt))}` : archived;
  return <StatusChip status="archived" includeArchived size="small" label={label} />;
};
